import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from "axios";
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest"
};

export const useCartStore = defineStore('cart', () => {
  const products = ref([]);
  const total = ref([]);

  ////////////////////////////////////////////////////////////////// Get data
  const get = () => {
    return axios.get(window.Laravel.shop.cart.get)
      .then(response => {
        products.value = response.data.items;
        total.value = response.data.total;
      })
      .catch(error => {
        console.error(error);
      });
  }

  const add = product => {
    return axios.post(window.Laravel.shop.cart.add, product)
      .then(response => {

        products.value = response.data.cart.items;
        total.value = response.data.cart.total;

        return response;

        // var sessionData = response.data.cart;

        // try {
        //   var addedProduct = response.data.cart.items.filter(item => item.variant_id == data.variant_id)[0];
        //   var dataLayerPayload = {
        //     'event': 'addToCart',
        //     'ecommerce': {
        //       'currencyCode': 'EUR',
        //       'add': {
        //         'products': [{
        //           'name': addedProduct.product_title,
        //           'id': addedProduct.product_id,
        //           'price': addedProduct.price,
        //           'brand': 'frogstoprinces',
        //           'category': addedProduct.product_category,
        //           'variant': addedProduct.title,
        //           'quantity': data.qty
        //         }]
        //       }
        //     }
        //   };
        //   console.log(dataLayerPayload);
        //   dataLayer.push(dataLayerPayload);
        // } catch (error) {
        //   console.error(error);
        // }
      })
      .catch(error => {
        return error;
      });
  }

  // const increaseProductQuantity = (context, data) => {
  //   return new Promise((resolve, reject) => {
  //     if (!data.quantity || data.quantity <= 0) {
  //       data.quantity = 1;
  //     }
  //     context.state.cartLoading = true;
  //     var _uri = '/' + window.Laravel.code + '/cart/increase/' + data.id + '/' + data.quantity;
  //     axios.get(_uri).then(function (response) {
  //       var sessionData = response.data.cart;
  //       context.commit('GET_CART_PRODUCTS', sessionData.items);
  //       context.commit('GET_CART_TOTALS', sessionData.total);
  //       resolve(response);
  //     })
  //       .catch(function (error) {
  //         reject(error);
  //         // console.log('error:', error);
  //       });
  //   });
  // }

  // const decreaseProductQuantity = (context, data) => {
  //   return new Promise((resolve, reject) => {
  //     if (!data.quantity || data.quantity <= 0) {
  //       data.quantity = 1;
  //     }
  //     context.state.cartLoading = true;
  //     var _uri = '/' + window.Laravel.code + '/cart/decrease/' + data.id + '/' + data.quantity;
  //     axios.get(_uri).then(function (response) {
  //       var sessionData = response.data.cart;

  //       var productToRemove;
  //       try {
  //         var productToRemove = response.data.product_removed;
  //         var dataLayerPayload = {
  //           'event': 'removeFromCart',
  //           'ecommerce': {
  //             'remove': { // 'remove' actionFieldObject measures.
  //               'products': [{ //  removing a product to a shopping cart.
  //                 'name': productToRemove.product_title,
  //                 'id': productToRemove.product_id,
  //                 'price': productToRemove.price,
  //                 'brand': 'frogstoprinces',
  //                 'category': productToRemove.product_category,
  //                 'variant': productToRemove.title,
  //                 'quantity': data.qty
  //               }]
  //             }
  //           }
  //         };
  //         console.log(dataLayerPayload);
  //         dataLayer.push(dataLayerPayload);
  //       } catch (error) {

  //       }


  //       context.commit('GET_CART_PRODUCTS', sessionData.items);
  //       context.commit('GET_CART_TOTALS', sessionData.total);
  //       resolve(response);
  //     })
  //       .catch(function (error) {
  //         console.log('error:', error);
  //         reject(error);
  //       });
  //   });
  // }

  // const removeProduct = (context, data) => {
  //   context.state.cartLoading = true;
  // }

  ////////////////////// Export store
  return {
    products,
    total,
    get,
    add
  };
});